import { useTranslation } from "react-i18next";

import CarouselCard from "../../atoms/CarouselCard/CarouselCard";
import Title from "../../atoms/Title/Title";
import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import CarouselSeeMoreImage from "../../../assets/images/carousel_plus_card.svg";

interface Props {
  onClick: () => void;
}

const SeeMoreCarouselCard = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <CarouselCard className="SeeMoreCarouselCard" onClick={onClick}>
      <Title variant="h2" style={{ textAlign: 'center', width: '100%' }}>{t('subscriptioncarousel:CARDSBLOCK_SEEMORE')}</Title>
      <LogoSvg src={CarouselSeeMoreImage} />
    </CarouselCard>
  );
};

export default SeeMoreCarouselCard;
